import React from "react";
import { Bio } from "../details/data";
import "../styles/About.css";
import Typewriter from "typewriter-effect";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";

const About = () => {
  return (
    <section className="about" id="about">
      <div className="leftContainer">
        <h1 className="greeting">Hi, I am</h1>
        <h1 className="name">{Bio.name}</h1>
        <p className="typeRoles">
          I am a
          <span className="typing">
            <Typewriter
              options={{
                strings: Bio.roles,
                autoStart: true,
                loop: true,
                delay: 100,
                deleteSpeed: 100,
              }}
            />
          </span>
        </p>
        <p className="description">{Bio.description}</p>
        <div
          onClick={() => {
            window.open(Bio.resume);
          }}
          className="resumeButton"
        >
          Check Resume
        </div>
      </div>
      <div className="rightContainer">
        <SentimentSatisfiedAltIcon style={{ fontSize: 300 }} />
      </div>
    </section>
  );
};
export default About;
